// Predating our use of the naming-convention rule, we referred to
// the keys of these enums in code. Rather than accidentally
// breaking something by changing their names, it's probably best
// to just shrug and move on.
/* eslint-disable @typescript-eslint/naming-convention */
export enum ChannelTypes {
  mobile = 'Mobile apps',
  web = 'Web',
  sms = 'SMS',
  email = 'Email',
  open = 'Open Channels',
  reach = 'Mobile Wallet',
}

export enum MobilePlatforms {
  ios = 'iOS',
  android = 'Android',
  wns = 'Windows 8',
  adm = 'Amazon',
}
/* eslint-enable */

// File under not remotely obvious, if you want the actual "keys" of an enum as
// a type you have to do this.
export type MobilePlatformKeys = keyof typeof MobilePlatforms
export type ChannelTypeKeys = keyof typeof ChannelTypes
export type AllChannelTypeKeys = MobilePlatformKeys | ChannelTypeKeys

export enum Direction {
  Asc = '',
  Desc = '-',
}

export interface Filters {
  direction: Direction
  on: 'created' | 'name'
  selectedPlatform?:
    | 'all'
    | 'web'
    | 'sms'
    | 'email'
    | 'open'
    | MobilePlatformKeys
  companyName?: string
  passType?: string
  contains?: string
  ownership?: 'owner' | 'team'
  status?: 'live' | 'test'
  type: 'all' | ChannelTypeKeys
}

export interface ReachProject {
  templates: Array<string>
  contextId: string
  projectType: string
  description: string
  settings: {
    barcode_encoding: string
    barcode_type: string
  }
  _meta: {
    isOwner: boolean
    companyId: number
    companyName: string
    friendlyType: string
  }
  updatedAt: string
  id: number
  createdAt: string
  name: string
}

export interface EngageApp {
  platforms: AllChannelTypeKeys[]
  is_configured: boolean
  name: string
  key: string
  created: string
  url: string
  shared: boolean
  type: 'production' | 'development' | 'demo'
  icon?: string
}

export type Project = EngageApp | ReachProject

export interface PageContext {
  reach_projects: Array<ReachProject>
  apps: Array<EngageApp>
  can_create_apps: boolean
  has_reach: boolean
  has_engage: boolean
  show_onboarding_tour: boolean
}

export interface Stats {
  hasEngage: boolean
  hasReach: boolean
  companyNames: Set<string>
  passTypes: Set<string>
  platforms: Set<AllChannelTypeKeys>
}

export interface AppListState {
  combinedList: Project[]
  filter: Filters
}
